<template>
    <div>
        <v-dialog @click:outside="cancel" width="1000" v-model="dialog">
            <v-card class="pa-6">
                <v-form ref="form" @submit.prevent="saveWithSign">
                    <v-card-title>{{ title }}</v-card-title>
                    <v-divider color="gray" />
                    <v-card
                        flat
                        tile
                        :color="step === 1 ? '#6B7BB2' : ''"
                        :class="step === 1 ? 'white--text' : ''"
                        max-width="128"
                        class="pa-4 font-weight-bold d-inline-block"
                    >
                        Шаг 1<br />
                        Заполнение
                    </v-card>
                    <v-card
                        :color="step === 2 ? '#6B7BB2' : ''"
                        flat
                        tile
                        max-width="130"
                        :class="step === 2 ? 'white--text' : ''"
                        class="pa-4 font-weight-bold d-inline-block mb-4"
                    >
                        Шаг 2<br />Подписание
                    </v-card>
                    <v-divider color="gray" />
                    <div v-if="step === 1">
                        <v-expansion-panels flat v-model="actPanel" multiple>
                            <RecipientInfo :abonentDebt.sync="abonentDebt" v-model="form" :info-create="infoCreate" :is-contract="isContract" />
                            <PrescribedInfoAccount :is-contract="isContract" v-model="form" v-if="isContract" :info-create="infoCreate" />
                            <CreateInfoAct v-model="form" :info-create="infoCreate" :is-contract="isContract" />
                            <PrescribedInfoAccount :is-contract="isContract" v-model="form" v-if="!isContract" :info-create="infoCreate" />
                            <ActionsInfo :abonentDebt="abonentDebt" :info-create="infoCreate" :is-contract="isContract" />
                            <MetersInfo v-if="!isContract" :act_date="form.act_date" :info-create="infoCreate" :is-contract="isContract" />
                        </v-expansion-panels>
                        <UploadDocuments class="pb-16" :uploadedFiles.sync="files" />
                        <div class="d-flex justify-end">
                            <v-btn @click="cancel" class="mr-4" color="gray" outlined rounded>отмена</v-btn>
                            <v-btn @click="saveWithoutSign" class="mr-4" color="gray" outlined rounded>
                                Сохранить<br />
                                без подписи
                            </v-btn>
                            <v-btn type="submit" class="mr-4 white--text" color="gray" rounded>
                                подписать
                            </v-btn>
                        </div>
                    </div>
                    <SignAct @cancel="cancel" @goToPreviousStep="goToPreviousStep" :transfer-data="transferData" :only_sign="only_sign" v-if="step === 2" />
                </v-form>
            </v-card>
        </v-dialog>
        <DeleteServiceActDialog v-model="deleteServiceActDialog" @confirmDeleteServiceAct="confirmDeleteServiceAct" />
        <AddServiceActDialog v-model="addServiceActDialog" @confirmAddServiceAct="confirmAddServiceAct" :items="infoCreate['other_serv']" />
    </div>
</template>
<script>
import UploadDocuments from '@/components/ui/UploadDocuments.vue';
import { validationRules } from '@/utils/validationRules';
import { mapActions } from 'vuex';
import PrescribedInfoAccount from '@/components/acts/CreateActComponents/PrescribedInfoAccount.vue';
import ActionsInfo from '@/components/acts/CreateActComponents/ActionsInfo.vue';
import MetersInfo from '@/components/acts/CreateActComponents/MetersInfo.vue';
import CreateInfoAct from '@/components/acts/CreateActComponents/CreateInfoAct.vue';
import RecipientInfo from '@/components/acts/CreateActComponents/RecipientInfo.vue';
import FileService from '@/services/apiRequests/file.service';
import DeleteServiceActDialog from '@/components/acts/DeleteServiceActDialog.vue';
import AddServiceActDialog from '@/components/acts/AddServiceActDialog.vue';
import SignAct from '@/components/acts/SignAct.vue';
import { mask } from '@/main';
import metersModule from '@/store/servorgs/meters.module';

export default {
    name: 'CreateAct',
    components: {
        SignAct,
        DeleteServiceActDialog,
        RecipientInfo,
        CreateInfoAct,
        ActionsInfo,
        MetersInfo,
        PrescribedInfoAccount,
        UploadDocuments,
        AddServiceActDialog
    },
    props: ['value', 'isContract', 'infoCreateModel'],
    inject: ['saveAct'],
    provide() {
        return {
            deleteService: this.deleteService,
            addService: this.addService
        };
    },
    data: function() {
        return {
            step: 1,
            only_sign: false,
            actPanel: [],
            files: [],
            deleteServiceActDialog: false,
            addServiceActDialog: false,
            serviceToDelete: null,
            form: {
                inspector_rid: null,
                act_date: new Date().toISOString().slice(0, 10),
                comment: null,
                consumer_representative: null,
                telephone_number: null,
                e_mail: null,
                reconnection_cost: null,
                heating_system_rid: null,
                injuction: {
                    injuction_rid: null,
                    period_execution: null,
                    injuction_done: null
                },
                serv: [],
                job_position_type_rid: null,
                job_position_type: null,
                abonent_was_not: false
            },
            transferData: {},
            abonentDebt: null
        };
    },
    computed: {
        validationRules() {
            return validationRules;
        },
        infoCreate: {
            get() {
                return this.infoCreateModel;
            },
            set(val) {
                this.$emit('update:infoCreateModel', val);
            }
        },
        dialog: {
            get() {
                return this.value;
            },
            set(val) {
                this.$emit('input', val);
            }
        },
        title() {
            return this.isContract ? 'Cоздание акта на отключение/подключение по объекту договора' : 'Cоздание акта на отключение/подключение лицевому счету';
        }
    },
    methods: {
        ...mapActions('refs', ['getInspectors']),
        ...mapActions('base', ['showMessage']),
        resetData() {
            this.dialog = false;
            this.step = 1;
            this.actPanel = [];
            this.files = [];
            this.form = {
                inspector_rid: null,
                act_date: new Date().toISOString().slice(0, 10),
                comment: null,
                consumer_representative: null,
                telephone_number: null,
                e_mail: null,
                reconnection_cost: null,
                injuction: {
                    injuction_rid: null,
                    period_execution: null,
                    injuction_done: null
                },
                serv: [],
                job_position_type_rid: null,
                job_position_type: null,
                abonent_was_not: false,
                meters: []
            };
            this.transferData = {};
        },
        cancel() {
            this.resetData();
        },
        preparePayload() {
            const keys = ['suppl_serv_rid', 'reason_rid', 'act_action_type_rid'];
            const serv = this.infoCreate['serv'].map(obj => {
                const newObj = {};
                keys.forEach(key => {
                    newObj[key] = obj[key];
                });
                return newObj;
            });
            const meter_keys = ['meter_number', 'new_indication', 'attachment_link_rid', 'indications', 'next_meter_verify_date', 'date_action'];
            const meters = this.infoCreate['meters']
                ? this.infoCreate['meters'].map(obj => {
                      const newObj = {};
                      meter_keys.forEach(key => {
                          newObj[key] = obj[key];
                      });
                      return newObj;
                  })
                : [];
            if (this.isContract) {
                this.form.obj_suppl_rid = this.infoCreate['obj_suppl_rid'];
            } else {
                this.form.account_rid = this.infoCreate['account_rid'];
            }
            return {
                ...this.form,
                serv,
                meters
            };
        },
        async saveWithoutSign() {
            if (!this.$refs.form.validate()) {
                this.showMessage({ message: 'Заполните обязательные поля', color: 'error' });
                return;
            }
            const payload = this.preparePayload();
            const response = await this.saveAct(payload);
            if (!response || !response.successfull) return;
            await FileService.downloadFile({ files: this.files, guid: response.data.guid, document: this.isContract ? 'object_act' : 'account_act' });
            this.resetData();
        },
        async saveWithSign() {
            if (!this.$refs.form.validate()) {
                this.showMessage({ message: 'Заполните обязательные поля', color: 'error' });
                return;
            }
            const payload = this.preparePayload();
            const response = await this.saveAct(payload);
            if (!response || !response.successfull) return;
            await FileService.downloadFile({ files: this.files, guid: response.data.guid, document: this.isContract ? 'object_act' : 'account_act' });
            this.step = 2;
            this.transferData = response.data;
        },
        deleteService(item) {
            this.deleteServiceActDialog = true;
            this.serviceToDelete = item;
        },
        confirmDeleteServiceAct() {
            if (this.isContract)
                this.infoCreate['other_serv'] = this.infoCreate['other_serv'].concat(
                    this.infoCreate['serv'].filter(service => service['suppl_serv_rid'] === this.serviceToDelete['suppl_serv_rid'])
                );
            this.infoCreate['serv'] = this.infoCreate['serv'].filter(service => service['suppl_serv_rid'] !== this.serviceToDelete['suppl_serv_rid']);
            this.deleteServiceActDialog = false;
            this.showMessage({ message: 'Услуга удалена из акта', color: 'success' });
        },
        addService() {
            this.infoCreate['other_serv'].map(function(a) {
                a.selected = false;
            });
            this.addServiceActDialog = true;
        },
        confirmAddServiceAct() {
            this.infoCreate['serv'] = (this.infoCreate['serv'] ?? []).concat(this.infoCreate['other_serv'].filter(service => service['selected']));
            this.infoCreate['other_serv'] = this.infoCreate['other_serv'].filter(service => !service['selected']);
            this.addServiceActDialog = false;
            //this.infoCreate['serv'] = this.infoCreate['serv'].filter(service => service['suppl_serv_rid'] !== this.serviceToDelete['suppl_serv_rid']);
            //this.deleteServiceActDialog = false;
        },
        goToPreviousStep() {
            this.step = 1;
        },
        async onlySign(id) {
            this.step = 2;
            this.only_sign = true;
            this.transferData = { record_id: id };
        }
    },
    watch: {
        infoCreate: {
            handler(newInfoCreate) {
                if (newInfoCreate.consumer_representative) {
                    this.form.consumer_representative = newInfoCreate.consumer_representative;
                }
                if (newInfoCreate.phone) {
                    this.form.telephone_number = newInfoCreate.phone;
                }
                if (this.infoCreateModel.mail) {
                    this.form.e_mail = newInfoCreate.mail;
                }
                this.abonentDebt = newInfoCreate['abonent_debt'];
            },
            immediate: true
        },
        abonentDebt() {
            if (this.abonentDebt) {
                this.infoCreate['serv'] = this.infoCreate['serv'].map(service => {
                    return {
                        ...service,
                        reason_rid: 15,
                        act_action_type_rid: 1
                    };
                });
            } else {
                this.infoCreate['serv'] = this.infoCreate['serv'].map(service => {
                    return {
                        ...service,
                        reason_rid: null,
                        act_action_type_rid: null
                    };
                });
            }
        }
    }
};
</script>

<style scoped></style>
